import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Report } from '@app/shared/features/reports/models/report.model';

@Component({
  selector: 'reports-nav',
  templateUrl: './reports-nav.component.html'
})
export class ReportsNavComponent {

  @Input() reportsTree: any;
  @Input() defaultItem?: Report;

  @Output() selected = new EventEmitter<Report>();

  isReportNode(nodeValue: any): boolean {
    return !!nodeValue?.type;
  }

  isActive(nodeValue: any): boolean {
    return (
      this.isReportNode(nodeValue) &&
      this.defaultItem?.reportId === nodeValue.reportId
    );
  }

  onSelect(nodeValue: any): void {
    if (!this.isReportNode(nodeValue)) {
      return;
    }

    this.selected.emit(nodeValue);
  }

  isSeparated(nodeValue: any): boolean {
    return !!nodeValue?.separated;
  }
}
